import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';
import { Box, Flex, Image } from 'rebass/styled-components';

import { ContactsEmptyState } from './emptyState';
import { SharedListEmptyState } from './sharedListEmptyState';
import { ContactsNoResults } from '../../components/atoms/ContactsNoResult';
import IconHandEmptyIcon from '../../assets/icon-hand-empty.svg';

export const EmptyContacts = ({
  showAllContactsEmptyState,
  showListContactsEmptyState,
  isLoading,
  isFetching,
  dataCount,
  listId,
  queryParams,
  defaultFilters,
  emptyState,
  type,
}) => {
  const hasFilters = !isEqual(defaultFilters, queryParams.filters);
  const isNoResults = !isLoading && !dataCount && hasFilters;
  const isSharedListEmpty = !isLoading && !isFetching && !dataCount && listId && !hasFilters;
  const isContactsEmpty = showAllContactsEmptyState || showListContactsEmptyState;

  // Shared list view with no contacts
  if (type === 'public' && !isFetching && !dataCount && !hasFilters) {
    return (
      <Flex mt="40px" flexDirection="column" alignItems="center" maxWidth="520px" mx="auto" textAlign="center">
        <Image src={IconHandEmptyIcon} width="64px" maxWidth="64px" />
        <Box mt="16px" fontWeight="semibold">
          This list is empty
        </Box>
        <Box as="span" mt="8px" fontSize="14px" color="text.subtle">
          Subscribe to get notifications when new people are added.
        </Box>
      </Flex>
    );
  }

  // List view: empty list with no active filters
  if (isSharedListEmpty) return emptyState || <SharedListEmptyState />;

  // All contacts or list: network has zero contacts
  if (isContactsEmpty) return <ContactsEmptyState isList={showListContactsEmptyState} />;

  // Any view: filters applied but no matching contacts
  if (isNoResults) return <ContactsNoResults isList={Boolean(listId)} type={type} />;

  return null;
};

EmptyContacts.propTypes = {
  showAllContactsEmptyState: PropTypes.bool,
  showListContactsEmptyState: PropTypes.bool,
  isLoading: PropTypes.bool,
  isFetching: PropTypes.bool,
  dataCount: PropTypes.number,
  listId: PropTypes.string,
  queryParams: PropTypes.object.isRequired,
  defaultFilters: PropTypes.object,
  emptyState: PropTypes.node,
  type: PropTypes.string,
};

EmptyContacts.defaultProps = {
  showAllContactsEmptyState: false,
  showListContactsEmptyState: false,
  isLoading: false,
  isFetching: false,
  dataCount: 0,
  listId: '',
  defaultFilters: {},
  emptyState: null,
  type: 'default',
};
